import { actionTypes } from "./viewsTypes";

const initialState = {
  newViewsCounter: 0,
  allViewsCounter: 0,
  viewsNewIds: [],
  viewsTodayIds: [],
  viewsYesterdayIds: [],
  viewsLastWeekIds: [],
  viewsLastMonthIds: [],
  viewsEarlierIds: [],

  viewsNewPreviews: [],
  viewsTodayPreviews: [],
  viewsYesterdayPreviews: [],
  viewsLastWeekPreviews: [],
  viewsLastMonthPreviews: [],
  viewsEarlierPreviews: [],

  viewsNewLoading: false,
  viewsTodayLoading: false,
  viewsYesterdayLoading: false,
  viewsLastWeekLoading: false,
  viewsLastMonthLoading: false,
  viewsEarlierLoading: false,

  previews: [], //delete
  isNew: false,
  pageWasVisited: false,
};

const viewsReducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case actionTypes.SET_VIEWS_IDS:
      return {
        ...state,
        newViewsCounter: payload.newViewsCounter,
        viewsNewIds: payload.viewsNewIds || [],
        viewsTodayIds: payload.viewsTodayIds || [],
        viewsYesterdayIds: payload.viewsYesterdayIds || [],
        viewsLastWeekIds: payload.viewsLastWeekIds || [],
        viewsLastMonthIds: payload.viewsLastMonthIds || [],
        viewsEarlierIds: payload.viewsEarlierIds || [],
        allViewsCounter: payload.allViewsCounter,
        isNew: false,
      };
//////////////////////////////////////////////////////////////////////////////////////// previews
    case actionTypes.SET_PREVIEWS_NEW:
      return {
        ...state,
        viewsNewPreviews: payload,
        viewsNewLoading: false,
        pageWasVisited: true
      };
    case actionTypes.SET_PREVIEWS_TODAY:
      return {
        ...state,
        viewsTodayPreviews: payload,
        viewsTodayLoading: false,
        pageWasVisited: true
      };
    case actionTypes.SET_PREVIEWS_YESTERDAY:
      return {
        ...state,
        viewsYesterdayPreviews: payload,
        viewsYesterdayLoading: false,
        pageWasVisited: true
      };
    case actionTypes.SET_PREVIEWS_WEEK:
      return {
        ...state,
        viewsLastWeekPreviews: payload,
        viewsLastWeekLoading: false,
        pageWasVisited: true
      };
    case actionTypes.SET_PREVIEWS_MONTH:
      return {
        ...state,
        viewsLastMonthPreviews: payload,
        viewsLastMonthLoading: false,
        pageWasVisited: true
      };
    case actionTypes.SET_PREVIEWS_EARLIER:
      return {
        ...state,
        viewsEarlierPreviews: payload,
        viewsEarlierLoading: false,
        pageWasVisited: true
      };
////////////////////////////////////////////////////////////////////////////////// loadings
    case actionTypes.SET_LOADING_NEW:
      return {
        ...state,
        viewsNewLoading: payload,
      };
    case actionTypes.SET_LOADING_TODAY:
      return {
        ...state,
        viewsTodayLoading: payload,
      };
    case actionTypes.SET_LOADING_YESTERDAY:
      return {
        ...state,
        viewsYesterdayLoading: payload,
      };
    case actionTypes.SET_LOADING_WEEK:
      return {
        ...state,
        viewsLastWeekLoading: payload,
      };
    case actionTypes.SET_LOADING_MONTH:
      return {
        ...state,
        viewsLastMonthLoading: payload,
      };
    case actionTypes.SET_LOADING_EARLIER:
      return {
        ...state,
        viewsEarlierLoading: payload,
      };
      case actionTypes.SET_LOADING_ALL:
      return {
        ...state,
        viewsEarlierLoading: payload,
        viewsLastMonthLoading: payload,
        viewsLastWeekLoading: payload,
        viewsYesterdayLoading: payload,
        viewsTodayLoading: payload,
        viewsNewLoading: payload,
      };
////////////////////////////////////////////////////////////////////
    case actionTypes.SET_VIEWS_NEW_COUNTER:
      return {
        ...state,
        newViewsCounter: payload,
      };
    case actionTypes.PUSH_NEW_PREVIEW:
      const tempArr = [...state.viewsNewPreviews];
      //@ts-ignore
      tempArr.unshift(...payload);
      return {
        ...state,
        viewsNewPreviews: tempArr,
        isNew: true,
      };
    case actionTypes.SET_PAGE_WAS_VISITED:
      return {
        ...state,
        pageWasVisited: payload
      }
    default:
      return state;
  }
};

export default viewsReducer;
